import { syncCallback } from "@de-xima/xima-common-js-lang";
import { runRemoteCommand } from "./Util.ts";

export async function initalUpdateLicenseStates(): Promise<void> {
  FacesHttp?.SocketApi?.onNoneConnecting(
    syncCallback(async () => {
      await runRemoteCommand(BackendCommand?.initalUpdateLicenseStates);
    }),
  );
}
